import { translate } from 'react-i18next';
import { compose, hoistStatics, lifecycle, withState, withHandlers } from 'recompose';
import TextTabs from './TextTabs';
import WithLoading from '../../../WithLoading';

const enhance = compose(
  withState('isLoading', 'setIsLoading', true),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      this.props.setIsLoading(false);
    },
  }),
  withHandlers({
  }),
);

export default hoistStatics(enhance)(WithLoading(TextTabs));



// WEBPACK FOOTER //
// ./src/components/modules/textTabs/simple/index.js